// extracted by mini-css-extract-plugin
export default {"serviceCardWrapper":"Footer_serviceCardWrapper__N4L2Q","swingUpDown":"Footer_swingUpDown__qk7YR"};